import { TrustBanner } from "../TrustBanner/TrustBanner";
import { TrustBannerImages } from "../TrustBanner/TrustBannerImages";
import { usePreload } from "../../hooks";
import type { InterventionProps } from "../../types";

export const Q2QEmbedTrustpilotBanner = (props: InterventionProps) => {
  const { data } = props;
  const componentNames = data?.component_names;
  usePreload(TrustBannerImages["trustpilot_alternate"].src);

  if (!componentNames || componentNames.length === 0) return null;
  if (componentNames.includes("control")) return null;
  if (componentNames.includes("trust-banner-variant-b")) {
    return <TrustBanner variant="trustpilot_alternate" />;
  }

  return null;
};
